import React from 'react';

// eslint-disable-next-line import/no-cycle
import { DensityCalculator } from '../../Insulation/DensityCalculator';

// eslint-disable-next-line react/prop-types
const CMSDensityCalculator = ({ header, displacementSections, caliperSections, footer }) => (
  <DensityCalculator
    header={header}
    displacementSections={displacementSections}
    caliperSections={caliperSections}
    footer={footer}
  />
);

export default CMSDensityCalculator;
